import React from 'react';
import PropTypes from 'prop-types';

import { NumberInput } from '@tillersystems/stardust';

const NumberField = ({ name, error, onChange, onBlur, options, value }) => {
  const { fluid = true, ...rest } = options;

  return (
    <NumberInput
      id={name}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      error={!!error}
      fluid={fluid}
      {...rest}
    />
  );
};

/** Prop types. */
NumberField.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  options: PropTypes.object,
  value: PropTypes.number,
};

/** Default prop types. */
NumberField.defaultProps = {
  options: {},
  onBlur: null,
  value: null,
  error: null,
};

export default NumberField;
